import { render, staticRenderFns } from "./SideResultFull.vue?vue&type=template&id=837e9d72&"
import script from "./SideResultFull.vue?vue&type=script&lang=js&"
export * from "./SideResultFull.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports